import { render } from "./TagSelectorMultiple.vue?vue&type=template&id=61b4b6be&scoped=true"
import script from "./TagSelectorMultiple.vue?vue&type=script&lang=js"
export * from "./TagSelectorMultiple.vue?vue&type=script&lang=js"

import "./TagSelectorMultiple.vue?vue&type=style&index=0&id=61b4b6be&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3624/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b4b6be"]])

export default __exports__